import {
    ACTION_HANDLE_START_FETCHING_NOTIFICATIONS,
    ACTION_HANDLE_STOP_FETCHING_NOTIFICATIONS,
    ACTION_MARK_NOTIFICATION_AS_READ,
    ACTION_HANDLE_UPDATE_NOTIFICATIONS_LIST,
    ACTION_MARK_NOTIFICATION_AS_READ_IN_LIST,
    ACTION_MARK_ALL_NOTIFICATIONS_AS_READ,
    ACTION_MARK_ALL_NOTIFICATIONS_AS_READ_REQUEST_INPROCESS,
    ACTION_MARK_ALL_NOTIFICATIONS_AS_READ_IN_LOCAL_LIST,
    ACTION_HANDLE_EMPTY_NOTIFICATIONS_LIST,
    ACTION_HANDLE_LOAD_MORE_NOTIFICATIONS,
    ACTION_HANDLE_UPDATE_IS_LOADING,
    ACTION_REMOVE_NOTIFICATION_IN_LIST,
    ACTION_REMOVE_NOTIFICATION_IN_LOCAL_LIST,
    ACTION_NOTIFICATION_IS_DELETING,
    ACTION_SET_NOTIFICATION_READ_REQUEST_INPROCESS
} from './actionTypes';

export const startFetchingNotifications = () => ({
    type: ACTION_HANDLE_START_FETCHING_NOTIFICATIONS
});

export const loadMoreNotifications = () => ({
    type: ACTION_HANDLE_LOAD_MORE_NOTIFICATIONS
});

export const stopFetchingNotifications = () => ({
    type: ACTION_HANDLE_STOP_FETCHING_NOTIFICATIONS
});

export const markNotificationAsRead = ({
    notificationId
}) => ({
    type: ACTION_MARK_NOTIFICATION_AS_READ,
    payload: {
        notificationId
    }
});

export const markAllNotificationsAsRead = () => ({
    type: ACTION_MARK_ALL_NOTIFICATIONS_AS_READ
});

export const setMarkAllNotificationsAsReadInprocess = ({
    newStatus
}) => ({
    type: ACTION_MARK_ALL_NOTIFICATIONS_AS_READ_REQUEST_INPROCESS,
    payload: {
        newStatus
    }
});

export const setMarkAllNotificationsAsReadInLocalList = () => ({
    type: ACTION_MARK_ALL_NOTIFICATIONS_AS_READ_IN_LOCAL_LIST
});

export const markNotificationAsReadLocalList = ({
    notificationId
}) => ({
    type: ACTION_MARK_NOTIFICATION_AS_READ_IN_LIST,
    payload: {
        notificationId
    }
});

export const setNotificationReadReqeustInprocess = ({
    notificationId,
    newStatus
}) => ({
    type: ACTION_SET_NOTIFICATION_READ_REQUEST_INPROCESS,
    payload: {
        notificationId,
        newStatus
    }
});

export const removeNotificationInList = ({
    notificationId
}) => ({
    type: ACTION_REMOVE_NOTIFICATION_IN_LIST,
    payload: {
        notificationId
    }
});

export const removeNotificationInLocalList = ({
    notificationId
}) => ({
    type: ACTION_REMOVE_NOTIFICATION_IN_LOCAL_LIST,
    payload: {
        notificationId
    }
});


export const notificationIsDeleting = ({
    notificationId,
    status,
}) => ({
    type: ACTION_NOTIFICATION_IS_DELETING,
    payload: {
        notificationId,
        status
    }
});


export const updateNotificationsList = ({
    totalCount,
    unreadCount,
    pageIndex,
    pageSize,
    list
}) => ({
    type: ACTION_HANDLE_UPDATE_NOTIFICATIONS_LIST,
    payload: {
        totalCount,
        unreadCount,
        pageIndex,
        pageSize,
        list
    }
});

export const emptyNotificationsList = () => ({
    type: ACTION_HANDLE_EMPTY_NOTIFICATIONS_LIST
});

export const updateIsLoadingStatus = ({
    status
}) => ({
    type: ACTION_HANDLE_UPDATE_IS_LOADING,
    payload: {
        status: status
    }
});